import src from "IMAGE";
export default { src, width: 1274, height: 637, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
